export const optionsPrice = [
  {
    display: 'price below $10',
    min: 0,
    max: 1000
  },
  {
    display: '$10 - $20',
    min: 1000,
    max: 2000
  },
  {
    display: '$20 - $30',
    min: 2000,
    max: 3000
  },
  {
    display: '$30 - $40',
    min: 3000,
    max: 4000
  },
  {
    display: 'price above $40',
    min: 4000,
    max: 100000
  }
]

export const optionsType = [
  {
    display: 'T-Shirt',
    type: 't-shirt'
  },
  {
    display: 'Hoodie',
    type: 'hoodie'
  },
  {
    display: 'Jacket',
    type: 'jacket'
  }
]

export const optionsColor = [
  {
    display: 'Black',
    color: 'black'
  },
  {
    display: 'White',
    color: 'white'
  },
  {
    display: 'Red',
    color: 'red'
  }
]

export const optionsSize = [
  {
    display: 'S',
    size: 's'
  },
  {
    display: 'M',
    size: 'm'
  },
  {
    display: 'L',
    size: 'l'
  },
  {
    display: 'XL',
    size: 'xl'
  }
]
